import React from 'react'
import './nav.css'
import {AiOutlineHome} from 'react-icons/ai';
import {FaUserTie} from 'react-icons/fa';
import {GiSkills} from 'react-icons/gi'
import {FcSelfServiceKiosk} from 'react-icons/fc'
import {FcContacts} from 'react-icons/fc'
import { useState } from 'react';
const Nav=()=> {
 const [activeNav,setActiveNav]=useState('#');
  return (
   <nav>
    <a href='#'onClick={()=>setActiveNav('#')} className={activeNav==='#' ? 'active':''}><AiOutlineHome/></a>
    <a href='#about' onClick={()=>setActiveNav('#about')} className={activeNav==='#about'?'active':''}><FaUserTie/></a>
    <a href='#experience' onClick={()=>setActiveNav('#experience')} className={activeNav==='#experience'?'active':''}><GiSkills/></a>
    <a href='#services'onClick={()=>setActiveNav('#services')} className={activeNav==='#services'?'active':''}><FcSelfServiceKiosk/></a>
    <a href='#contact'onClick={()=>setActiveNav('#contact')} className={activeNav==='#contact'?'active':''}><FcContacts/></a>
   </nav>
  )
}

export default Nav